/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Desk_NowInputs */

const en_features_desk_now = /** @type {(inputs: Features_Desk_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`now`)
};

const pl_features_desk_now = /** @type {(inputs: Features_Desk_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`teraz`)
};

/**
* | output |
* | --- |
* | "now" |
*
* @param {Features_Desk_NowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_now = /** @type {((inputs?: Features_Desk_NowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_NowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_now(inputs)
	return en_features_desk_now(inputs)
});